import React from 'react'

import Empty from 'components/uiKit/Empty'
import { KitSize } from 'components/uiKit/KitTypes'
import { AppMode } from 'services/Store/Project/enums'
import { t } from 'services/Translation'

import * as s from './TableElementForm.module.scss'
import type { TableFormValueType } from './tableTypes'

const TableElementForm: TableFormValueType = ({ mode }) => {
  const isPro = mode.editorMode === AppMode.pro
  return (
    <div className={s.root}>
      <Empty
        icon='settings'
        size={KitSize.XS}
        text={
          isPro
            ? t('elements.table.form.proMode.emptyDescription')
            : t('elements.table.form.contentMode.emptyDescription')
        }
        grow
      />
    </div>
  )
}

export default React.memo(TableElementForm)
